/**
 * formatImage
 *
 * @param image - image file name
 *
 * Fortmats image paths to include minIO
 */
export const formatImage = (image) => `https://${process.env.NEXT_PUBLIC_STORAGE_ENDPOINT}/mjr/photos/${image}`;
